/** URL paths for the trilingual technology salary guide — April 2026 (no trailing slash). */
export const TECHNOLOGY_SALARY_GUIDE_202604_URL_PATHS = {
  en: '/en/resources/jobs-in-finland/technology-salary-guide-finland-2026-04',
  fi: '/fi/tyoelama/tyot-suomessa/teknologia-palkkaopas-suomi-2026-04',
  sv: '/sv/arbetsliv/jobb-i-finland/teknologi-loeneguide-finland-2026-04',
} as const;

export type TechnologySalaryGuide202604Locale = keyof typeof TECHNOLOGY_SALARY_GUIDE_202604_URL_PATHS;
